// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__2WkNg","illusions":"style_illusions__1bNeI","eliteSlot":"style_eliteSlot__1uC-_"};